export const BNP_CARBON_PROGRAM_ID = "b69af6ce-1c47-40ca-9562-64e08cc5eab7";
export const CARGILL_DE_CARBON_PROGRAM_ID = "c7befc81-c2a8-43bc-8269-1491036348c7";
export const WELTGOLD_UNILEVER_CARBON_PROGRAM_ID = "3165fc41-7a95-8ee0-dba2-4d9ffa54442d";
